<section class="auth__pane">
  <header class="auth__pane-header">
    <span class="auth__brand">
      <img
        class="auth__brand-logo"
        ngSrc="/logo-icon.png"
        alt=""
        width="32"
        height="32"
        priority
        aria-hidden="true"
      />
      <span class="auth__brand-name">Savant</span>
    </span>
    <a class="btn btn--ghost btn--sm" href="mailto:support&#64;savantpayments.co.zw">
      <i class="ph ph-lifebuoy" aria-hidden="true"></i>Need help?
    </a>
  </header>

  <div class="auth__pane-body">
    <router-outlet />
  </div>

  <p class="auth__legal">
    &copy; {{ year }} Savant Payment Gateway. Backoffice Portal. Authorised access only.
  </p>
</section>

<aside class="auth__aside" aria-hidden="true">
  <div class="auth__aside-mark">
    <img class="auth__aside-logo" ngSrc="/logo-icon.png" alt="" width="40" height="40" />
    <span class="auth__aside-name">Savant Payment Gateway</span>
  </div>

  <div class="auth__aside-copy">
    <p class="auth__quote">The switch, its partners and every cent that moves through it.</p>

    <div class="auth__points">
      <span class="auth__point">
        <i class="ph ph-arrows-left-right"></i>Transactions and statements across every channel
      </span>
      <span class="auth__point">
        <i class="ph ph-percent"></i>Channel pricing maintained in one place
      </span>
      <span class="auth__point">
        <i class="ph ph-shield-check"></i>Partner credentials issued and rotated under control
      </span>
    </div>
  </div>

  <div class="auth__stats">
    <div>
      <div class="auth__stat-value">Multi-currency</div>
      <div class="auth__stat-label">Accounts &amp; settlement</div>
    </div>
    <div>
      <div class="auth__stat-value">Real time</div>
      <div class="auth__stat-label">Transaction monitoring</div>
    </div>
  </div>
</aside>
